import OndemandApi from 'common/api/OndemandApi';
import ServiceGeometries from 'ondemand/types/ServiceGeometries';


const odApi = new OndemandApi();

export const REQUEST_SERVICE_GEOMETRIES = 'REQUEST_SERVICE_GEOMETRIES';

export function requestServiceGeometries() {
  return {type: REQUEST_SERVICE_GEOMETRIES};
}

export const RECEIVE_SERVICE_GEOMETRIES = 'RECEIVE_SERVICE_GEOMETRIES';

export function receiveServiceGeometries(json) {
  return {
    type: RECEIVE_SERVICE_GEOMETRIES,
    info: json,
  };
}

export function fetchServiceGeometries(agencyId, serviceId) {
  return (dispatch) => {
    dispatch(requestServiceGeometries());
    return odApi.fetchServiceGeometries({agencyId, serviceId})
      .then(response => response.json())
      .then(item => new ServiceGeometries(item))
      .then(obj => dispatch(receiveServiceGeometries(obj)))
      ;
  };
}

function shouldFetchServiceGeometries(state, agencyId, serviceId) {
  const geometries = state.serviceGeometries;
  if (geometries && geometries.isFetching) {
    return false;
  }
  if (!geometries || !geometries.item) {
    return true;
  } else if (geometries.agencyId !== agencyId || geometries.serviceId !== serviceId) {
    return true;
  }
  return false;
}

export const _shouldFetchServiceGeometries = shouldFetchServiceGeometries; // For testing

export function fetchServiceGeometriesIfNeeded(agencyId, serviceId) {
  return (dispatch, getState) => {
    if (shouldFetchServiceGeometries(getState(), agencyId, serviceId)) {
      return dispatch(fetchServiceGeometries(agencyId, serviceId));
    }
    return Promise.resolve();
  };
}



// WEBPACK FOOTER //
// ./src/ondemand/actions/serviceGeometries.js